import { __read, __spread } from "tslib";
import update from 'immutability-helper';
import { hexToRgba, hsbaToRgba, hslaToRgba, rgbaToHex, rgbaToHsba, rgbaToHsla, } from './utils';
import { PropertyClass } from '../types';
import { ColorFormat } from './types';
export function create(options) {
    if (options === void 0) { options = {}; }
    return Object.assign({
        className: PropertyClass.Color,
        rgbaValues: [0, 0, 0, 1],
    }, options);
}
export function createFromRgba(rgbaValues) {
    if (rgbaValues === void 0) { rgbaValues = [0, 0, 0, 1]; }
    return create({
        className: PropertyClass.Color,
        rgbaValues: rgbaValues,
    });
}
export function createFromHex(hex, opacity) {
    if (hex === void 0) { hex = '#000000'; }
    return create({
        className: PropertyClass.Color,
        rgbaValues: hexToRgba(hex, opacity) || undefined,
    });
}
export function createFromHsla(_a) {
    var _b = __read(_a, 4), H = _b[0], S = _b[1], L = _b[2], A = _b[3];
    return create({
        className: PropertyClass.Color,
        rgbaValues: hslaToRgba([H, S, L, A]),
    });
}
export function createFromHsba(_a) {
    var _b = __read(_a, 4), H = _b[0], S = _b[1], B = _b[2], A = _b[3];
    return create({
        className: PropertyClass.Color,
        rgbaValues: hsbaToRgba([H, S, B, A]),
    });
}
export function createFromCSSRgb(cssRgb) {
    var parts = cssRgb
        .split('(')[1]
        .replace(')', '')
        .split(',')
        .map(function (n) { return Number(n) / 255; });
    return createFromRgba([
        // TODO I've not figured out a shorthand for typing array -> tuple conversions
        parts[0],
        parts[1],
        parts[2],
        1,
    ]);
}
export function setOpacity(color, opacity) {
    return update(color, {
        rgbaValues: {
            '3': {
                $set: opacity,
            },
        },
    });
}
export function getHex(color) {
    return rgbaToHex(color.rgbaValues);
}
export function getRgba(color) {
    return color.rgbaValues;
}
export function getOpacity(color) {
    return color.rgbaValues[3];
}
export function getHsla(color) {
    return rgbaToHsla(color.rgbaValues);
}
export function getHsba(color) {
    return rgbaToHsba(color.rgbaValues);
}
export function variantToColor(variant) {
    // eslint-disable-next-line default-case
    switch (variant.format) {
        case ColorFormat.Hex:
            return createFromHex(variant.value);
        case ColorFormat.Hsla:
            return createFromHsla(variant.value);
        case ColorFormat.Hsba:
            return createFromHsba(variant.value);
        case ColorFormat.Rgba:
            return createFromRgba(variant.value);
    }
}
export function colorToVariant(color, colorFormat) {
    // eslint-disable-next-line default-case
    switch (colorFormat) {
        case ColorFormat.Hex:
            return { format: colorFormat, value: getHex(color) };
        case ColorFormat.Hsla:
            return { format: colorFormat, value: getHsla(color) };
        case ColorFormat.Hsba:
            return { format: colorFormat, value: getHsba(color) };
        case ColorFormat.Rgba:
            return { format: colorFormat, value: __spread(getRgba(color)) };
    }
}
export function getCssRgba(color) {
    var _a = __read(getRgba(color), 4), r = _a[0], g = _a[1], b = _a[2], a = _a[3];
    return "rgba(" + r * 255 + ", " + g * 255 + ", " + b * 255 + ", " + a + ")";
}
export function createFromCSSRgba(cssRgb) {
    var rgba = cssRgb
        .split('(')[1]
        .replace(')', '')
        .split(',')
        .map(function (n, i) { return (i < 3 ? Number(n) / 255 : Number(n)); });
    return createFromRgba(rgba);
}
